<template>
    <v-layout wrap column class="layout-add layout-add--max_width">
        <v-flex xs12 justify-center align-center class="d-flex loader">
            <img src="/static/img/logo.png" alt="loader" class="loader-background"/>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: 'LoaderLayout'
    }
</script>
